<template>
	<popup-view v-bind="$attrs" @close="$emit('close')">
		<clock-view :value="value" @input="input" />
	</popup-view>
</template>

<script>
	export default {
		props: {
			value: {
				type: [Number, String]
			},
			owner: {
				
			}
		},
		methods: {
			input(value) {
				console.log(value);
				
				if (this.owner) {
					this.owner.input(value);
				}
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>